export default "__VITE_ASSET__Cpua4gOt__"